package com.example.mystybag.sharedmodels.project.requestModels

import com.example.mystybag.sharedmodels.AllCommands.GET_ALL_API
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class GetAllBagsRequestModel(
    var userId              : Long      = 0L,
    var clientLat           : Double    = 0.0,
    var clientLng           : Double    = 0.0,
    var clientTimeZoneId    : String = ""
): BaseRequestModel(api = GET_ALL_API)